import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({}));

export default useStyles;
